import VehicleObject from './finance/vehicle-object';
import NewVehicleFinance from './finance/new-vehicle-finance';
import getAvailableFinanceParameters from './finance/get-available-parameters';
import { getFromStorage } from '../../../used-vue/api/Storage';
import debounce from 'lodash/debounce';

export default function(customerRef = '') {
    const vehicle = new VehicleObject(document.querySelector('.new-car-details'));
    const finance = new NewVehicleFinance(vehicle, customerRef);

    // Debounce the finance request and ensure the final request is sent across
    window.financeChanged = debounce(() => {
        finance.getFinance();
    }, 750, {
        leading: true,
        trailing: true
    });

    // Load in any customer parameters from storage
    finance.customerParameters.setTerm(getFromStorage('new_term', finance.customerParameters.term));
    if (typeof forceTerm !== 'undefined') {
        finance.customerParameters.setTerm(forceTerm);
    }
    finance.customerParameters.setDeposit(getFromStorage('new_deposit', finance.customerParameters.deposit));
    if (typeof forceDeposit !== 'undefined') {
        finance.customerParameters.setDeposit(forceDeposit);
    }
    finance.customerParameters.setMileage(getFromStorage('new_mileage', finance.customerParameters.mileage));
    if (typeof forceMileage !== 'undefined') {
        finance.customerParameters.setMileage(forceMileage);
    }
    finance.customerParameters.setPostcode(getFromStorage('new_postcode', finance.customerParameters.postcode));
    finance.customerParameters.setAge(getFromStorage('new_age', finance.customerParameters.age));

    // Collect all the available finance keys from CW, and then update the constraints for each key
    getAvailableFinanceParameters(vehicle).then(response => {
        finance.financeTypes.forEach(financeType => {
            let keyAvailable = false;
            response.Products.forEach(cwProduct => {
                if (financeType.key.toLowerCase() == cwProduct.Key.toLowerCase()) {
                    keyAvailable = true;
                    financeType.constrain(cwProduct);
                }
            });
            // If we didn't find the key in the response, then remove it from the available keys
            if (!keyAvailable) {
                finance.financeTypes = finance.financeTypes.filter(element => {
                    if (element.alwaysShow) {
                        return true;
                    }
                    return (element.key !== financeType.key);
                });
            }
        });

        finance.sortFinanceTypes();
        const financeTypeDropdown = document.getElementById('finance-type');
        const financeTypeSingle = document.getElementById('finance-type-single');
        finance.buildFinanceTypeDropDown(financeTypeDropdown);
        if (finance.financeTypes.length > 1) {
            financeTypeDropdown.style.display = 'block';
            financeTypeSingle.style.display = 'none';
        } else if (finance.financeTypes.length == 1) {
            financeTypeDropdown.style.display = 'none';
            financeTypeSingle.innerHTML = finance.financeTypes[0].longName || 'Finance';
            financeTypeSingle.style.display = 'block';
        } else {
            financeTypeDropdown.style.display = 'none';
            financeTypeSingle.innerHTML = 'No finance available';
            financeTypeSingle.style.display = 'block';
        }

        finance.financeTypes.forEach(element => {
            element.init(finance.customerParameters);
        });
        $('.finance-calculator .loading').remove();

        $('#finance-type').on('change', function() {
            // Change the finance key to the newly selected value
            finance.changeFinanceKey($(this).val());
            // Update the parameters to the ranges allowable for the new finance type
            finance.currentFinanceType.renderer.updateParameters(finance.customerParameters);
            // Hide unrelated calculators
            $('div[data-finance-calculator]').hide();
            // Show the associated calculator
            $('div[data-finance-calculator="'+ finance.currentFinanceType.pseudoKey +'"]').show();
            // Trigger the finance changed event
            window.financeChanged();
        });

        let keyFound = false;
        if (typeof forceFinanceType !== 'undefined') {
            // Go through each of the finance types we collected and see if the pseudoKey matches first
            finance.financeTypes.forEach(financeType => {
                if (keyFound !== false) {
                    return;
                }
                if (financeType.pseudoKey == forceFinanceType) {
                    keyFound = financeType.pseudoKey;
                }
            });
            if (!keyFound) {
                finance.financeTypes.forEach(financeType => {
                    if (keyFound !== false) {
                        return;
                    }
                    if (financeType.key == forceFinanceType) {
                        keyFound = financeType.pseudoKey;
                    }
                });
            }
            if (keyFound !== false) {
                $(financeTypeDropdown).val(keyFound).trigger('change');
            }
        }

        if (keyFound === false) {
            $('div[data-finance-calculator]').hide();
            $('div[data-finance-calculator="'+ finance.currentFinanceType.pseudoKey +'"]').show();
            finance.getFinance();
        }

    });

    $("input[name='postcode']").on('change.consistency', function() {
        $("input[name='postcode']").val(this.value);
    });
    $("input[name='age']").on('change.consistency', function() {
        $("input[name='age']").val(parseInt(this.value));
    });

    return finance;
}


// WEBPACK FOOTER //
// ./resources/assets/js/new-car-pages/modules/details/initialise-finance.js